import { PricingMethodology } from '@constants/constants';
import { formatCurrency as generalFormatCurrency } from '@utils/common';
import { LabeledValueProp } from '../components/LabeledValue';

export const formatPercentage = (value: string | number) => {
  const numValue = Number(value);
  if (isNaN(numValue)) return '-';

  const formattedValue = (numValue * 100).toFixed(2);

  if (Number(formattedValue) === -0) return '0.00%';

  return `${formattedValue}%`;
};

export const formatCurrency = (value: string | number) => {
  if (Number(value) === 0) return '$0.00';

  return generalFormatCurrency(value);
};

export const getPricingDetails = (
  pricingMethodology: PricingMethodology,
  interest: string,
): LabeledValueProp[] => {
  if (pricingMethodology === PricingMethodology.SIMPLE_INTEREST) {
    try {
      const { SIMPLE_INTEREST_RATE } = JSON.parse(interest || '{}');

      return [
        {
          label: 'Interest %',
          value: SIMPLE_INTEREST_RATE,
          formatValue: formatPercentage,
        },
      ];
    } catch (error: any) {
      console.error(error);
      return [];
    }
  } else if (
    [PricingMethodology.DYNAMIC_RETURN_CAP, PricingMethodology.DYNAMIC_RETURN_CAP_V2].includes(
      pricingMethodology,
    )
  ) {
    try {
      const { BASE_RATE, DYNAMIC_RATE } = JSON.parse(interest || '{}');

      return [
        {
          label: 'First Month Cap',
          value: BASE_RATE,
          formatValue: formatPercentage,
        },
        {
          label: 'Incremental Return Cap',
          value: DYNAMIC_RATE,
          formatValue: formatPercentage,
        },
      ];
    } catch (error: any) {
      console.error(error);
      return [];
    }
  } else {
    return [{ label: 'Custom Pricing', value: interest }];
  }
};
